import React from 'react';
import { Chip } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledChip = styled(Chip)(({ theme }) => ({
    height: 24,
    fontSize: '0.6875rem',
    fontWeight: 600,
    borderRadius: 4,

    '& .MuiChip-label': {
        padding: '0 8px',
    },

    '&.MuiChip-sizeSmall': {
        height: 20,
        fontSize: '0.625rem',
    },
}));

const LsChip = ({
    label,
    status, // 'active', 'pending', 'overdue', 'legal', 'settled'
    size = 'small',
    ...props
}) => {
    const statusColorMap = {
        active: 'primary',
        pending: 'warning',
        overdue: 'error',
        legal: 'secondary',
        settled: 'success',
        default: 'default',
        error: 'error',
        warning:'warning',
        secondary:'secondary',
        info:'info'
    };

    const color = status ? statusColorMap[status] || 'default' : props.color || 'default';

    return (
        <StyledChip
            label={label}
            color={color}
            size={size}
            {...props}
        />
    );
};

export default LsChip;